import { ProfileIcon, PaperIcon, HideIcon } from '@/assets/icons';
import type { IconComponent } from '@/types/types';
import { BOOKING_VISIBILITY_TYPES, type BookingVisibilityType } from '../model';

/**
 * Дефолтное значение видимости бронирования для новых вишлистов
 */
export const DEFAULT_BOOKING_VISIBILITY: BookingVisibilityType = 'hide_names';

export interface BookingVisibilityOption {
  id: BookingVisibilityType;
  labelKey: string;
  descriptionKey: string;
  icon: IconComponent;
}

/**
 * Опции видимости бронирования
 * labelKey и descriptionKey используются для i18n (features.createWishlist.bookingVisibility.{id}.label/description)
 * Порядок элементов соответствует BOOKING_VISIBILITY_TYPES (SSOT)
 */
export const BOOKING_VISIBILITY_OPTIONS: BookingVisibilityOption[] = BOOKING_VISIBILITY_TYPES.map((id) => {
  // Маппинг иконок и i18n ключей для каждого типа видимости бронирования
  const config: Record<BookingVisibilityType, { icon: IconComponent; labelKey: string; descriptionKey: string }> = {
    show_names: {
      icon: ProfileIcon,
      labelKey: 'wishlist:createWishlist.bookingVisibility.show_names.label',
      descriptionKey: 'wishlist:createWishlist.bookingVisibility.show_names.description',
    },
    hide_names: {
      icon: PaperIcon,
      labelKey: 'wishlist:createWishlist.bookingVisibility.hide_names.label',
      descriptionKey: 'wishlist:createWishlist.bookingVisibility.hide_names.description',
    },
    hide_all: {
      icon: HideIcon,
      labelKey: 'wishlist:createWishlist.bookingVisibility.hide_all.label',
      descriptionKey: 'wishlist:createWishlist.bookingVisibility.hide_all.description',
    },
  };

  return {
    id,
    ...config[id],
  };
});